import { useSelector, shallowEqual } from 'react-redux';

import { selectPaymentMethod } from 'state/payment-method/payment-method-slice';
import {
  PAYMENT_NAMES,
  PAYMENT_METHODS,
  PAYMENT_METHODS_NEP,
  ACCEPTED_PAYMENT_METHOD,
  PARTNERS
} from 'config/app-config';
import { usePartner } from 'components/app/routes/usePartner';

export const usePaymentMethod = () => {
  const { partnerName, acceptedPaymentMethods } = usePartner();
  // TODO: Remove type assertion when usePartner is converted to TypeScript
  // usePartner() returns null for partnerName but provides acceptedPaymentMethods with proper fallback
  const defaultPaymentMethod = (ACCEPTED_PAYMENT_METHOD[
    partnerName as string
  ] || ACCEPTED_PAYMENT_METHOD[PARTNERS.DIRECT_SALES])[0];
  const selectedPaymentMethod = useSelector(selectPaymentMethod, shallowEqual);
  const paymentMethod = selectedPaymentMethod || defaultPaymentMethod;

  const isMonthlyDirectDebit =
    paymentMethod === PAYMENT_METHODS.MONTHLY_DIRECT_DEBIT;
  const isQuaterylyVariableDirectDebit =
    paymentMethod === PAYMENT_METHODS.QUATERLY_VARIABLE_DIRECT_DEBIT;
  const isCashCheque = paymentMethod === PAYMENT_METHODS.CHECK;
  const isPrePay = paymentMethod === PAYMENT_METHODS.PREPAY;

  const paymentName = PAYMENT_NAMES[paymentMethod];
  const paymentMethodNEP = PAYMENT_METHODS_NEP[paymentMethod];
  const hasMultipleDirectDebitTypes = [
    PAYMENT_METHODS.MONTHLY_DIRECT_DEBIT,
    PAYMENT_METHODS.QUATERLY_VARIABLE_DIRECT_DEBIT
  ].every((pMethod) => acceptedPaymentMethods.includes(pMethod));
  const isAnyDirectDebit = !!(
    isMonthlyDirectDebit || isQuaterylyVariableDirectDebit
  );

  return {
    hasMultipleDirectDebitTypes,
    isMonthlyDirectDebit,
    isQuaterylyVariableDirectDebit,
    isCashCheque,
    isPrePay,
    isAnyDirectDebit,
    paymentMethod,
    paymentName,
    paymentMethodNEP // used to sent to NEP API
  };
};

export type TUsePaymentMethod = ReturnType<typeof usePaymentMethod>;
